export default "__VITE_ASSET__DPraIN27__"